import MuiAlertTitle from '@material-ui/lab/AlertTitle';
import { withStyles } from '@material-ui/core/styles';

// Empty styles are just to help with console errors due to prop validation
const AlertTitle = withStyles(() => ({
  root: {},
}))(MuiAlertTitle);

export default AlertTitle;
